import styled from 'styled-components';

export const NotificationsLayout = styled.div.attrs({
  className: 'notifications',
})`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const NotificationsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const NotificationsHeaderContent = styled.div.attrs({
  className: 'notifications__header-content',
})`
  display: flex;
  align-items: center;
`;

export const NotificationsHeader = styled.h1.attrs({
  className: 'notifications__header',
})`
  margin: 0 10px 0 0;
`;

export const FilterButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
